export default __webpack_public_path__ + "static/media/perth-zoo-logo.56e5c321.png";